import { createContext } from 'react';

/** The inspector's pinned strip above the summary; tab content portals into it. */
export const InspectorFooterContext = createContext<HTMLElement | null>(null);
